import type {
  AddCatchWidgetApiInitDisposeFaults,
  AddCatchWidgetApiInitFaults,
} from "@skbkontur/loader-builder";
import { createImportWidgetModule } from "@skbkontur/widget-framework-npm-loader-helper";
import type { ImportWidgetModule } from "@skbkontur/widget-framework-npm-loader-helper";
import type {
  RenderDisposeFault as RenderDisposeFaultInternal,
  RenderFault as RenderFaultInternal,
} from "./private.js";
import type {FiasComboBoxProps, FiasFormProps, FiasWidgetApi, EventBusConstructor} from "./common.js";

// TODO Все ошибки, которые может увидеть потребитель при отрисовке виджета (вызове функции render)
export type RenderFault = AddCatchWidgetApiInitFaults<RenderFaultInternal>;

// TODO Все ошибки, которые может увидеть потребитель при убирании (вызове функции dispose) отрисованного виджета с экрана (результата работы функции render).
export type RenderDisposeFault = AddCatchWidgetApiInitDisposeFaults<RenderDisposeFaultInternal>;

// TODO Список аргументов, необходимых для отрисовки виджета с помощью функции `render`
export type RenderParamsFias = {
  // Контейнер где будет отрисован виджет и куда виджет будет добавлять стили. Рекомендуется передавать явно. Исключение - виджеты, которые являются модальным окном сайдпейджем.
  readonly container: HTMLElement;
  // TODO Дополнительные параметры отрисовки, которые могут быть разными при последовательных или одновременных вызовах функции render
  readonly props: FiasFormProps;
  readonly scope: string;
};

export type RenderParamsFiasCombobox = {
  // Контейнер где будет отрисован виджет и куда виджет будет добавлять стили. Рекомендуется передавать явно. Исключение - виджеты, которые являются модальным окном сайдпейджем.
  readonly container: HTMLElement;
  // TODO Дополнительные параметры отрисовки, которые могут быть разными при последовательных или одновременных вызовах функции render
  readonly props: FiasComboBoxProps;
  readonly eventBus?: EventBusConstructor;
  readonly scope: string;
  readonly locale?: "ru" | "en" | undefined;
};

type PlatformTypes = {
  // TODO зависимости которые обязательны для работы виджета. Зависимости не могут быть изменены без полной перезагрузки виджета (выгрузка iframe и загрузка заново).
  ImportDependencies: {
    readonly apiUrl: URL;
    // Идентификатор потребителя (аналог integratorId). Рекомендуется использовать публичный портальный апи-ключ как общеконтуровское решение.
    readonly apiKey: string;
    readonly userId: string;
  };
  // TODO Ошибки, которые может вернуть разработчик виджета в jsLoader при импорте. Например, ошибки валидации.
  JsLoaderGetDependenciesFaults: never;
  // TODO Ошибки, которые может вернуть разработчик виджета в виджете при импорте. Например, ошибки инициализации начального стейта, телеметрии или при недоступности API. Рекомендуем использовать принцип fail-fast: если что-то не получилось, то сразу возвращать ошибку. В этом случае не нужно сообщаться потребителю что все хорошо и возвращать нерабочее фронтовое API.
  // TODO Рекомендуем возвращать разные ошибки для разных случаев. Это поможет потребителю понять, стоит ли повторить загрузку виджета. Например, если запрос к API упал, то загрузку повторить нужно. А если нет доступа - не нужно.
  WidgetImportFaults: never;
  // TODO Ошибки, которые могут вернуть разработчик виджета в при завершении работы виджета и очистке ресурсов (в том числе удалении iframe) с помощью функции dispose. Может возникнуть только после успешного создания фронтового апи виджета.
  DisposeFaults: never;
  // TODO реализуй здесь спроектированное публичное фронтовое API виджета (контракт). Рекомендуем использовать функциональный стиль, без мутаций. Рекомендуется в одном потребителе создавать только один экземпляр фронтового API виджета на все время жизни приложения.
  WidgetApi: FiasWidgetApi;
  JsLoaderImportsFaults: never;
};

// Типы экспортированные как default не попадут в сбоку к потребителям
export type { PlatformTypes as default };

export const importWidgetModule: ImportWidgetModule<PlatformTypes> = createImportWidgetModule();

// TODO Экспортируй дополнительные типы, константы, функции, необходимые потребителю для встройки виджета. Все экспорты и реэкспорты в этом файле увидит потребитель.
export type { FiasFormProps, FiasComboBoxProps };
export type { FiasValue, FiasFieldsSettings, GetFormState, FiasCountry, FiasAllFields, FiasFullValue, ValidationChangedPayload, ValueChangeOptions } from "./common.ts"
export { getAddressText, isAddressEmpty, FiasSchema, FiasDivision, FiasSuggestLevels, FiasFormValidation, FiasExtraFields, FiasFields, EventBusConstructor } from "./common.js";
export { FiasDataTids } from "./consts.js";
export { getAddressByFiasId, getAddressByString } from "./api.js";
export { WithValidationTransport } from "./react.js";
